// import React, { useMemo } from "react";
// import { useTranslation } from "react-i18next";
// import CorporateIcon from "../../../icons-svg/icon_corporate.svg";
// import IndividualIcon from "../../../icons-svg/icon_individual.svg";

// const InfoRow = ({ label, value }) => {
//   const showValue =
//     value === null || value === undefined || value === "" ? "" : String(value);


//   return (
//     <div
//       className="
//         grid
//         grid-cols-[minmax(120px,160px)_1fr]
//         sm:grid-cols-[minmax(160px,220px)_1fr]
//         lg:grid-cols-[minmax(220px,320px)_1fr]
//         gap-x-3 gap-y-1
//         items-start
//         min-w-0
//       "
//     >
//       <span
//         className="
//           font-medium
//           text-gray-800 dark:!text-white
//           whitespace-nowrap truncate
//           min-w-0
//         "
//         title={label}
//       >
//         {label}:
//       </span>

//       <span
//         className="
//           min-w-0
//           text-gray-700 dark:!text-white
//           font-bold
//           break-words whitespace-normal
//           text-left
//         "
//         title={showValue}       
//       >
//         {showValue || "-"}
//       </span>
//     </div>
//   );
// };


// const LicenseHolderInfo = ({ data }) => {
//   const { t } = useTranslation();

//   const holderData = useMemo(() => {
//     const base = data?.licenseHolder || data || {};
//     return {
    
//       fullLegalName: base.fullLegalName || "",
//       representativeName: base.representativeName || "",
//       representativePosition: base.representativePosition || "",
//       email: base.email || "",
//       companyRegistryNumber: base.companyRegistryNumber || "",
//       address: base.address || "",
//       refPartner: base.refPartner || "",
//       group: base.group || ""
//     };
//   }, [data]);

//   const corporateFields = [
//     { key: "licenceHolder", label: t("Licence Holder"), value: holderData.licenseHolder },
//     { key: "fullLegalName", label: t("Full legal (trade) name"), value: holderData.owner }, 
//     { key: "representativeName", label: t("Representative Name"), value: holderData.ownerRepresentativeName },
//     { key: "representativePosition", label: t("Representative Position"), value: holderData.ownerRepresentativePosition },
//     { key: "email", label: t("Email"), value: holderData.ownerMail }, 
//     { key: "companyRegistryNumber", label: t("Company Registry Number"), value: holderData.ownerRegistryNo },
//     { key: "address", label: t("Address"), value: holderData.ownerAddress },    
//     { key: "refPartner", label: t("Ref. partner"), value: holderData.refPartner }, 
//     { key: "group", label: t("Group"), value: holderData.group },   
//   ]; 
//   return (
//     <div className="text-sm">
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//         {/* Corporate */} 
//         <section className="min-w-0">
//           <div className="flex items-center gap-2 mb-3">
//             <img
//               src={CorporateIcon}
//               alt="Corporate"
//               className="w-5 h-5"
//               title={t("Corporate")}
//             />
//           </div>

//           <div className="space-y-2">
//             {corporateFields.map((f) => (
//               <InfoRow key={f.key} label={f.label} value={f.value} />
//             ))}
//           </div>
//         </section>

//         {/* Individual */}
//         <section className="min-w-0">
//           <div className="flex items-center gap-2 mb-3">
//             <img
//               src={IndividualIcon}
//               alt="Individual"
//               className="w-5 h-5"
//               title={t("Individual")}
//             />
//           </div>

//         </section>
//       </div>
//     </div>
//   );
// };

// export default LicenseHolderInfo;


import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import CorporateIcon from "../../../icons-svg/icon_corporate.svg";
import IndividualIcon from "../../../icons-svg/icon_individual.svg";

const InfoRow = ({ label, value, rightSlot, hideDash }) => {
  const hasValue =
    value !== null &&
    value !== undefined &&
    String(value).trim() !== "";

  return (
    <div
      className="
        grid
        grid-cols-[minmax(120px,160px)_1fr]
        sm:grid-cols-[minmax(160px,220px)_1fr]
        lg:grid-cols-[minmax(220px,320px)_1fr]
        gap-x-3 gap-y-1
        items-center
        min-w-0
      "
    >
      {/* Label */}
      <span className="font-medium text-gray-800 dark:!text-white whitespace-nowrap truncate">
        {label}:
      </span>

      {/* Value + optional icons */}
      <div className="flex items-center min-w-0">
        <span className="text-gray-700 dark:!text-white font-bold break-words">
          {hasValue ? value : hideDash ? "" : "-"}
        </span>

        {/* İkonlar value alanında */}
        {rightSlot && (
          <div className="flex items-center gap-[20px]">
            {rightSlot}
          </div>
        )}
      </div>
    </div>
  );
};

const LicenseHolderInfo = ({ data }) => {
  const { t } = useTranslation();

  const holderData = useMemo(() => {
    const base = data?.licenseHolder || data || {};

    return {
      licenseHolder: base.licenseHolder || "",
      owner: base.owner || "",
      ownerRepresentativeName: base.ownerRepresentativeName || "",
      ownerRepresentativePosition: base.ownerRepresentativePosition || "",
      ownerMail: base.ownerMail || "",
      ownerRegistryNo: base.ownerRegistryNo || "",
      ownerAddress: base.ownerAddress || "",
      refPartner: base.refPartner || "",
      group: base.group || "",
    };
  }, [data]);

  const corporateFields = [
    { key: "licenceHolder", label: t("Licence Holder"), value: holderData.licenseHolder },
    { key: "fullLegalName", label: t("Full legal (trade) name"), value: holderData.owner },
    { key: "representativeName", label: t("Representative Name"), value: holderData.ownerRepresentativeName },
    { key: "representativePosition", label: t("Representative Position"), value: holderData.ownerRepresentativePosition },
    { key: "email", label: t("Email"), value: holderData.ownerMail },
    { key: "companyRegistryNumber", label: t("Company Registry Number"), value: holderData.ownerRegistryNo },
    { key: "address", label: t("Address"), value: holderData.ownerAddress },
    { key: "refPartner", label: t("Ref. partner"), value: holderData.refPartner },
    { key: "group", label: t("Group"), value: holderData.group },
  ];

  const licenceHolderIcons = (
    <>
      <img
        src={CorporateIcon}
        alt="Corporate"
        title={t("Corporate")}
        className="w-5 h-5 cursor-pointer"
      />
      <img
        src={IndividualIcon}
        alt="Individual"
        title={t("Individual")}
        className="w-5 h-5 cursor-pointer"
      />
    </>
  );

  return (
    <div className="text-sm">
      <div className="grid grid-cols-1 gap-6">
        <section className="min-w-0">
          <div className="space-y-2">
            {corporateFields.map((f) => (
              <InfoRow
                key={f.key}
                label={f.label}
                value={f.value}
                rightSlot={f.key === "licenceHolder" ? licenceHolderIcons : null}
                hideDash={f.key === "licenceHolder"}
              />
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default LicenseHolderInfo;